import type { ReactNode } from 'react';
import { useRef } from 'react';
import { Transition } from 'react-transition-group';

import classNames from 'classnames';

import { visuallyHidden } from '../../../../styles';
import transitions from './transitions';

export interface AccordionTransitionProps {
  /** Whether or not the item is open */
  in: boolean;
  children: ReactNode;
}

export function AccordionTransition(props: AccordionTransitionProps) {
  const inAnimation = 'slideDown';
  const outAnimation = 'slideUp';
  const inTransition = transitions[inAnimation];
  const outTransition = transitions[outAnimation];

  const stateTransitions: Record<string, string> = {
    entering: inTransition.transitions.entering,
    exiting: outTransition.transitions.exiting,
    ...transitions.base.transitions,
  };

  const nodeRef = useRef(null);

  return (
    <Transition
      in={props.in}
      timeout={{
        enter: inTransition.duration,
        exit: outTransition.duration,
      }}
      nodeRef={nodeRef}
    >
      {(state): ReactNode => {
        return (
          <div
            ref={nodeRef}
            className={classNames(
              inAnimation,
              outAnimation,
              stateTransitions.init,
              stateTransitions[state],
              //For a11y purposes, we want to render the content of the accordion
              //in the DOM all the time and hide it visually when it's closed.
              {
                [visuallyHidden]: state === 'exited',
              }
            )}
          >
            {props.children}
          </div>
        );
      }}
    </Transition>
  );
}
